import { FlexBox } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { GridCalloutRow } from './GridCalloutRow'
import { GridCalloutCard, GridCalloutTheme } from './types'
import { GridCalloutImageBox } from './GridCalloutImageBox'

interface Props {
  className?: string
  textContent: React.ReactNode
  imageContent: React.ReactNode
  cards: GridCalloutCard[]
  reverse?: boolean
  theme: GridCalloutTheme
}

export const GridCallout = ({
  className = '',
  textContent,
  cards,
  imageContent,
  theme,
  reverse = false,
}: Props) => {
  const { mediaQueries } = useTheme()

  return (
    <div className={className}>
      <FlexBox
        className={css`
          flex-direction: column-reverse;
          justify-content: flex-start;
          align-items: stretch;
          gap: 32px;
          ${mediaQueries.mobileL} {
            flex-direction: ${reverse ? 'row-reverse' : 'row'};
            justify-content: space-between;
            align-items: center;
            gap: 0;
          }
        `}
      >
        <FlexBox
          className={css`
            width: 100%;
            ${mediaQueries.mobileL} {
              width: 50%;
            }
          `}
          justifyContent="center"
        >
          {textContent}
        </FlexBox>
        <GridCalloutImageBox theme={theme}>{imageContent}</GridCalloutImageBox>
      </FlexBox>
      <GridCalloutRow theme={theme} cards={cards} />
    </div>
  )
}
